import { render } from "./key-account-details.vue?vue&type=template&id=2f398ecd&scoped=true"
import script from "./key-account-details.vue?vue&type=script&lang=js"
export * from "./key-account-details.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./key-account-details.vue?vue&type=style&index=1&id=2f398ecd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f398ecd"]])

export default __exports__